import { render, staticRenderFns } from "./CertificateSetting.vue?vue&type=template&id=c60b5e26&scoped=true"
import script from "./CertificateSetting.vue?vue&type=script&lang=js"
export * from "./CertificateSetting.vue?vue&type=script&lang=js"
import style0 from "./CertificateSetting.vue?vue&type=style&index=0&id=c60b5e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60b5e26",
  null
  
)

export default component.exports